import { z } from "zod";
import {
  TRawBaseInfoField,
  TRawNumberInfoFieldValue,
  TRawTimestampInfoFieldValue,
  TRawNumberArrayInfoFieldValue,
  TRawGeoPointInfoFieldValue,
  TRawStringArrayInfoFieldValue,
  TRawStringInfoFieldValue,
  TRawArrayInfoFieldValue,
} from "../../infoField";

export type IRawPropertyFinanceInfoField = z.infer<
  typeof TRawPropertyFinanceInfoField
>;
export const TRawPropertyFinanceInfoField = z
  .object({
    fields: z
      .object({
        balanceSheetValue: TRawNumberInfoFieldValue,
        grossYield: TRawNumberInfoFieldValue,
        initialLoan: TRawNumberInfoFieldValue,
        jointCost: TRawNumberInfoFieldValue,
        marketValue: TRawNumberInfoFieldValue,
        purchaseDate: TRawTimestampInfoFieldValue,
        purchaseSum: TRawNumberInfoFieldValue,
        remainingLoan: TRawNumberInfoFieldValue,
        totalJointCost: TRawNumberInfoFieldValue,
      })
      .partial(),
  })
  .extend(TRawBaseInfoField.shape)
  .nullable();

export type IRawPropertyGeneralInfoField = z.infer<
  typeof TRawPropertyGeneralInfoField
>;
export const TRawPropertyGeneralInfoField = z
  .object({
    fields: z
      .object({
        address: TRawStringInfoFieldValue,
        architects: TRawStringInfoFieldValue,
        bnr: TRawStringInfoFieldValue,
        buildingOwner: TRawStringInfoFieldValue,
        builtArea: TRawNumberInfoFieldValue,
        city: TRawStringInfoFieldValue,
        constructionYear: TRawStringInfoFieldValue,
        constructionArea: TRawStringInfoFieldValue,
        energyScore: TRawStringInfoFieldValue,
        fireSafetyResponsibles: TRawStringArrayInfoFieldValue,
        floors: TRawArrayInfoFieldValue,
        gnr: TRawStringInfoFieldValue,
        heatedArea: TRawNumberInfoFieldValue,
        heatingScore: TRawStringInfoFieldValue,
        insuranceCompanies: TRawStringInfoFieldValue,
        jointArea: TRawNumberInfoFieldValue,
        location: TRawGeoPointInfoFieldValue,
        managementCompanies: TRawStringInfoFieldValue,
        maxPeopleAllowed: TRawNumberInfoFieldValue,
        municipality: TRawStringInfoFieldValue,
        municipalityNumber: TRawStringInfoFieldValue,
        netArea: TRawNumberInfoFieldValue,
        ownedArea: TRawNumberInfoFieldValue,
        plotArea: TRawNumberInfoFieldValue,
        postalAddress: TRawStringInfoFieldValue,
        primaryArea: TRawNumberInfoFieldValue,
        protectionClass: TRawStringInfoFieldValue,
        rentableArea: TRawNumberInfoFieldValue,
        rentedArea: TRawNumberInfoFieldValue,
        fireClass: TRawStringInfoFieldValue,
        riskClass: TRawStringInfoFieldValue,
        secondaryArea: TRawNumberInfoFieldValue,
        snr: TRawStringInfoFieldValue,
        totalArea: TRawNumberInfoFieldValue,
        totalParkingSpots: TRawNumberInfoFieldValue,
        usageArea: TRawNumberInfoFieldValue,
        visitorAddress: TRawStringInfoFieldValue,
      })
      .partial(),
  })
  .extend(TRawBaseInfoField.shape)
  .nullable();

export type IRawPropertyNoteInfoField = z.infer<
  typeof TRawPropertyNoteInfoField
>;
export const TRawPropertyNoteInfoField = z
  .object({
    fields: z
      .object({
        note: TRawStringInfoFieldValue,
      })
      .partial(),
  })
  .extend(TRawBaseInfoField.shape)
  .nullable();
